import { settings } from 'settings';
import Fetch from 'utils/fetch';
import { InboundInfo } from './fetchInbound';

export async function fetchInboundForPickups(): Promise<InboundInfo[]> {
  try {
    const response: Response = await Fetch.get({
      url: `${settings.newApiUrl}/inbound/getAllInboundInfo`,
    });

    if (response.ok) {
      const InboundInfoList: InboundInfo[] = await response.json();
      return InboundInfoList;
    }
  } catch (error) {
    return [];
  }
}
